import { render, staticRenderFns } from "./HeaderProjectToggler.vue?vue&type=template&id=28cc3ba2&scoped=true&"
import script from "./HeaderProjectToggler.vue?vue&type=script&lang=js&"
export * from "./HeaderProjectToggler.vue?vue&type=script&lang=js&"
import style0 from "./HeaderProjectToggler.vue?vue&type=style&index=0&id=28cc3ba2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc3ba2",
  null
  
)

export default component.exports